module.exports = __webpack_public_path__ + "media/home_top_bg.94e6879e.mp4";